import {HTTP} from "../http";

export default {
    namespaced: true,

    state: {
        loading: false,
        page: null
    },

    mutations: {
        setLoading(state, loading) {
            state.loading = loading;
        },

        setPage(state, page) {
            state.page = page;
        },

        setBlank(state) {
            state.page = {
                content: '',
                title: '',
                published: false
            };
        }
    },

    actions: {
        load({commit}, id) {
            commit('setLoading', true);

            return HTTP.get('/pages/' + id)
                .then(resp => {
                    commit('setLoading', false);
                    commit('setPage', resp.data);
                });
        },

        save({commit, state}) {
            commit('setLoading', true);

            if(state.page.id === undefined) {
                return HTTP.post('/admin/pages/new', state.page)
                    .then(() => commit('setLoading', false))
                    .then(() => commit('setPage', null))
                    .catch(err => context.commit('error/set', err.response.data, { root: true }));
            } else if (state.page.id !== undefined) {
                return HTTP.post('/admin/pages/' + state.page.id, state.page)
                    .then(() => commit('setLoading', false))
                    .then(() => commit('setPage', null))
                    .catch(err => context.commit('error/set', err.response.data, { root: true }));
            }
        },

        delete({ commit, state }) {
            return HTTP.delete('/admin/pages/' + state.page.id)
                .then(() => commit('setPage', null))
                .catch(err => context.commit('error/set', err.response.data, { root: true }));
        }
    }
}


// WEBPACK FOOTER //
// ./src/store/admin-page.js